import Fetch from '@/utils/Fetch';

const getQueriesForCustomer = async (customerID: any, pageSize: any, pageIndex: any, searchPhrase: any, sortExpression: any, sortDirection: any, includeClosed: any, toast = null) => {
    let params = {
        pageSize: pageSize,
        pageIndex,
        searchPhrase,
        sortExpression,
        sortDirection,
        customerIDList: [customerID],
        includeClosed,
    };

    return await Fetch.post({
        url: '/Query/GetQueries',
        params: params,
        toastCtx: toast
    });
};

const getQuery = async (queryID: any, caller = null) => {
    return await Fetch.get({
        url: `/Query/${queryID}`,
        caller: caller!
    });
};

const getCounts = async (queryID: any) => {
    let countRequest = await Fetch.get({
      url: `/Query/GetCounts?id=${queryID}`,
    });
    let result = countRequest.Results;
    let quoteCount = result.find((x: any) => x.Key == 'Quotes').Value;
    let invoiceCount = result.find((x: any) => x.Key == 'Invoices').Value;
    let puchaseOrderCount = result.find((x: any) => x.Key == 'PurchaseOrders').Value;
    let appointmentCount = result.find((x: any) => x.Key == 'Appointments').Value;
    let attachmentCount = result.find((x: any) => x.Key == 'Attachments').Value;
    let communicationCount = result.find((x: any) => x.Key == 'Communication').Value;
    let queryStatusChangesCount = result.find((x: any) => x.Key == 'QueryStatusChanges')?.Value || 0;
    let jobCount = result.find((x: any) => x.Key == 'Jobs').Value;

    return {quoteCount, invoiceCount, puchaseOrderCount, appointmentCount, attachmentCount, communicationCount, queryStatusChangesCount, jobCount};
};

const updateQuery = async (query: any, toast = null) => {
    return await Fetch.put({
        url: '/Query',
        params: {
          query
        },
        toastCtx: toast
    });
};

const closeQuery = async (queryID: any, toast = null) => {
    return await Fetch.get({
        url: '/Query/Close?id=' + queryID,
        toastCtx: toast
    });
};

const openQuery = async (queryID: any, toast = null) => {
    return await Fetch.get({
        url: '/Query/Open?id=' + queryID,
        toastCtx: toast
    });
};

const archiveQueryToggle = async (queryID: any, toast = null) => {
    return await Fetch.get({
        url: '/Query/Archive?id=' + queryID,
        toastCtx: toast
    });
};

export default {
    getQueriesForCustomer,
    getQuery,
    getCounts,
    updateQuery,
    closeQuery,
    openQuery,
    archiveQueryToggle,
};
